import { Text } from "@clipboard-health/ui-components";

import { type Consequence } from "./ConsequencePill";
import { getConsequenceDisplay } from "./getConsequenceDisplay";

interface ConsequenceTextProps {
  consequence: Consequence;
}

export function ConsequenceText({ consequence }: ConsequenceTextProps) {
  const { label, color } = getConsequenceDisplay(consequence);

  return (
    <Text inline semibold variant="body2" color={color}>
      {label}
    </Text>
  );
}
